import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { installAdminAuthFetch } from "@/lib/adminAuthFetch";
import { captureAttribution } from "@/lib/promoAttribution";
import { initMeta } from "@/lib/metaPixel";
import { CookieBanner } from "@/components/CookieBanner";
import { installGlobalErrorLog } from "@/lib/clientLog";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import PromoApp from "@/components/PromoApp";

installGlobalErrorLog();
installAdminAuthFetch();
captureAttribution();
initMeta();

// Arrivée directe sur la page Promotions (pubs) : coquille légère, le site complet se charge ensuite à la navigation
const isPromoEntry = /[?&]page=promotions(&|$)/.test(window.location.search) && !window.location.pathname.startsWith("/produit/");
const App = lazy(() => import("@/App"));
const Root = isPromoEntry ? PromoApp : App;

const Loader = () => (
  <div className="min-h-screen bg-zinc-950 flex items-center justify-center" data-testid="root-loading">
    <div className="h-8 w-8 rounded-full border-2 border-zinc-700 border-t-amber-400 animate-spin" />
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <AuthProvider>
        <Suspense fallback={<Loader />}>
          <Root />
        </Suspense>
        <CookieBanner />
      </AuthProvider>
    </AppErrorBoundary>
  </React.StrictMode>,
);
